<template>
  <div class="container">
      <div class="row">
          <div class="col-lg-12" v-html="content"></div>
      </div>
  </div>
</template>

<script>
  var marked = require("marked")
  marked.setOptions({
      headerIds: false
  });

  import content from '../pages_content/app321.md';

  export default {
      name: 'App321',
      data() {
          return {
              content: this.md(content)
          }
      },
      methods: {
          md: function(val){
              return marked(val);
          }
      }
  }
</script>

<style scoped>
.container {
  margin-top: 115px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/App321.vue